module.exports = __webpack_public_path__ + "img/NG.29448ac5.jpg";